export const enum ApplicationStatus {
    complete = 'complete',
    declined = 'declined',
    inspection = 'inspection',
    processing = 'processing',
    error = 'error',
    loading = 'loading',
    waiting = 'waiting',
}

export type ApplicationState =
    | 'ACCEPT_OFFER_MAIN_APPLICANT'
    | 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT'
    | 'PPI_MAIN_APPLICANT'
    | 'KYC_MAIN_APPLICANT'
    | 'SIGN_AGREEMENT'
    | 'APPLICATION_COMPLETE'
    | 'APPLICATION_FINAL_DECLINED'
    | 'MANUAL_INSPECTION'
    | 'MANUAL_VERIFICATION'
    | 'RULES_VERIFICATION'
    | 'ERROR_EXCEPTION'
    | 'TRANSITION'
    | 'UPDATE_INDEX'
    | 'VALIDATE_DEBT'
    | 'CREATE_CUSTOMER_AND_ACCOUNT'
    | 'SAVE_CONSENTS'
    | 'BOOK_TRANSACTION'
    | 'PREPARE_FOR_DISBURSEMENT'
    | 'READY_FOR_DISBURSEMENT'
    | 'CO_SUBMIT'
    | 'KYC_CO_APPLICANT'
    | 'WAITING_FOR_MAIN_APPLICANT'
    | 'WAITING_FOR_CO_APPLICANT'
    | 'COMPLEMENT_INFORMATION_CONSOLIDATIONS'
    | 'COMPLEMENT_INFORMATION_MAIN_APPLICANT';

export const applicationStatusFromState = (applicationState?: ApplicationState): ApplicationStatus => {
    switch (applicationState) {
        case 'APPLICATION_COMPLETE':
            return ApplicationStatus.complete;

        case 'APPLICATION_FINAL_DECLINED':
            return ApplicationStatus.declined;

        case 'MANUAL_INSPECTION':
            return ApplicationStatus.inspection;

        case 'MANUAL_VERIFICATION':
            return ApplicationStatus.inspection;

        case 'RULES_VERIFICATION':
            return ApplicationStatus.inspection;

        case 'ERROR_EXCEPTION':
            return ApplicationStatus.error;

        case 'TRANSITION':
            return ApplicationStatus.processing;

        case 'UPDATE_INDEX':
            return ApplicationStatus.complete;

        case 'VALIDATE_DEBT':
            return ApplicationStatus.complete;

        case 'CREATE_CUSTOMER_AND_ACCOUNT':
            return ApplicationStatus.complete;

        case 'SAVE_CONSENTS':
            return ApplicationStatus.complete;

        case 'BOOK_TRANSACTION':
            return ApplicationStatus.complete;

        case 'PREPARE_FOR_DISBURSEMENT':
            return ApplicationStatus.complete;

        case 'READY_FOR_DISBURSEMENT':
            return ApplicationStatus.complete;

        case 'WAITING_FOR_MAIN_APPLICANT':
            return ApplicationStatus.waiting;

        case 'WAITING_FOR_CO_APPLICANT':
            return ApplicationStatus.waiting;

        default:
            return ApplicationStatus.loading;
    }
};

export const doPollForApplicationStatus = (applicationStatus: ApplicationStatus): boolean =>
    applicationStatus === ApplicationStatus.processing;
